import React, { useEffect, useState } from "react";
import DynamicModal from "../shared/DynamicModal";
import CustomSelect from "../shared/CustomSelect";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import useGetData from "../Custom-Hooks/useGetData";
import { useLoading } from "./../../context/LoadingContext";
import axios from "axios";
import './../../css/ToggleSwitch.css';
import GlobalLoader from "../shared/GlobalLoader";
import SuccessPopup from "../shared/SuccessPopup";
import UserRoleOptions from "../../utils/UserRoleOptions";
import { dateTimeFormatter } from "../../utils/dateTimeFormatter";
import ConfirmPopup from "../shared/ConfirmPopup";
import { truncateText } from "../../utils/textTruncateUtils";
import { PAGE_ACCESS_IDS } from "../../utils/navbarMenuPermissions";

const UserManagement = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const accessToken = sessionStorage.getItem("accessToken");
    const navigate = useNavigate();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [toggleStates, setToggleStates] = useState({});
    const { isLoading, setLoading } = useLoading();
    const [shouldRefetch, setShouldRefetch] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState({
        type: "",
        show: false,
        message: ""
    });

    const headers = accessToken
        ? {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
        }
        : { "Content-Type": "application/json" };

    // get all users data from API
    const { data: allUserData, isLoading: getLoading, refetch } = useGetData(`${baseUrl}/user`);

    useEffect(() => {
        if (shouldRefetch) {
            refetch(); // manually re-fetch user data
            setShouldRefetch(false); // reset trigger
        }
    }, [shouldRefetch, refetch]);

    useEffect(() => {
        if (allUserData?.data) {
            const initialToggleStates = {};
            allUserData.data.forEach(user => {
                initialToggleStates[user.id] = user.status === 'ACTIVE';
            });
            setToggleStates(initialToggleStates);
        }
    }, [allUserData]);

    const initialFormData = {
        firstname: "",
        lastname: "",
        username: "",
        email: "",
        role_id: "",
        designation: "",
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState(initialFormData);
    const [searchQuery, setSearchQuery] = useState('');
    const [userAccessPage, setUserAccessPage] = useState("");


    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = allUserData?.data?.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(allUserData?.data?.length / rowsPerPage) || 1;

    const newUserField = [
        {
            id: "firstname",
            type: "text",
            name: "firstname",
            placeholder: "",
            label: "First Name",
            required: true,
            position: 1,
        },
        {
            id: "lastname",
            type: "text",
            name: "lastname",
            placeholder: "",
            label: "Last Name",
            required: true,
            position: 2,
        },
        {
            id: "username",
            type: "text",
            name: "username",
            placeholder: "",
            label: "User Name",
            required: true,
            position: 3,
        },
        {
            id: "email",
            type: "text",
            name: "email",
            placeholder: "",
            label: "Email",
            required: true,
            position: 4,
        },
        {
            id: "role_id",
            type: "select",
            name: "role_id",
            placeholder: "",
            label: "Role",
            required: true,
            position: 5,
            options: UserRoleOptions
        },
        {
            id: "designation",
            type: "test",
            name: "designation",
            placeholder: "",
            label: "Designation",
            required: true,
            position: 6,
        },
    ];

    const newUserFieldForamt = newUserField.sort(
        (a, b) => a.position - b.position
    );

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleCloseModal = () => {
        setFormData(initialFormData);
        setIsModalOpen(false);
    };

    const handleEditUser = async (User) => {
        setFormData(User);
        setIsModalOpen(true);
    };

    const handleSave = async () => {
        try {
            setLoading(true);


            const payload = {
              firstname: formData?.firstname || "",
              lastname: formData?.lastname || "",
              email: formData?.email,
              role_id: Number(formData?.role_id),
              username: formData?.username,
              designation: formData?.designation,
              ...(!formData?.id && {
                access_control: JSON.stringify([
                  {
                    id: PAGE_ACCESS_IDS.DASHBOARD,
                    name: "Dashboard",
                    children: [
                      { id: PAGE_ACCESS_IDS.DASHBOARD_SYSTEM_ANALYSIS, name: "System Analysis" },
                      { id: PAGE_ACCESS_IDS.DASHBOARD_PIPE_ANALYSIS, name: "Pipe Analysis" },
                      { id: PAGE_ACCESS_IDS.DASHBOARD_PSM, name: "PSM" },
                      { id: PAGE_ACCESS_IDS.DASHBOARD_AMMONIA_INVENTORY, name: "Ammonia Inventory" },
                      { id: PAGE_ACCESS_IDS.DASHBOARD_TASKS, name: "Tasks" }
                    ]
                  },
                  {
                    id: PAGE_ACCESS_IDS.DOC_STORE,
                    name: "Doc Store",
                    children: [
                      { id: PAGE_ACCESS_IDS.DOC_STORE_PNID, name: "P & ID" },
                      { id: PAGE_ACCESS_IDS.DOC_STORE_ENGINEERING_DRAWINGS, name: "Engineering Drawings" },
                      { id: PAGE_ACCESS_IDS.DOC_STORE_LAD, name: "LAD" },
                      { id: PAGE_ACCESS_IDS.DOC_STORE_MEB, name: "MEB" },
                      { id: PAGE_ACCESS_IDS.DOC_STORE_MASTER_LIST, name: "Master List" },
                      { id: PAGE_ACCESS_IDS.DOC_STORE_REPORTS, name: "Reports" },
                      { id: PAGE_ACCESS_IDS.DOC_STORE_USER_FILES, name: "Work Space" }
                    ]
                  },
                  {
                    id: PAGE_ACCESS_IDS.CONTACT_US,
                    name: "Contact Us"
                  }
                ])
              })
            };
            

            const url = formData.id ? `${baseUrl}/user/${formData?.id}` : `${baseUrl}/user/createUser`;

            const method = formData.id ? "put" : "post";

            const response = await axios[method](`${url}`, JSON.stringify(payload), { headers });

            setLoading(false);
            
            if (response.status === 200 || response.status === 201) {
                setShouldRefetch(true);
                setShowSuccessPopup({
                    type: "success",
                    show: true,
                    message: method === 'post' ? 'User Created Successfully' : 'User Updated Successfully',
                });
                if (response.data.httpStatusCode === 409) {
                    setShowSuccessPopup({
                        type: "warning",
                        show: true,
                        message: response.data.message,
                    });
                }
            }  else {
                setShowSuccessPopup({
                    type: "warning",
                    show: true,
                    message: response.message || "Something went wrong.",
                });
            }
        } catch (error) {
            setLoading(false);
            setShowSuccessPopup({
                type: "warning",
                show: true,
                message: error?.response?.data?.message || "Failed, Please try again",
            });
        }
    };

    const handleAccessUser = (user) => {
        navigate('user-access', { state: { user } });
    };

    const handleDeleteUser = (user) => {
        setSelectedUser(user);
        setShowConfirmPopup(true);
    }

    const handleConfirmDelete = async () => {
        try {
            setLoading(true);
            const response = await axios.delete(
                `${baseUrl}/user/${selectedUser?.id}`,
                { headers }
            );
            if (response.status === 200 || response.status === 201) {
                setShouldRefetch(true);
                setShowConfirmPopup(false);
                setShowSuccessPopup({
                    type: "success",
                    show: true,
                    message: 'User Deleted Successfully',
                });
            }

            setLoading(false);
        } catch (error) {
            setShowConfirmPopup(false);
            setLoading(false);
            setShowSuccessPopup({
                type: "warning",
                show: true,
                message: error?.response?.data?.message,
            });
        }
    };


    const filteredData = currentData?.filter(user => {
        const query = searchQuery.toLowerCase();
        return (
            user.firstname?.toLowerCase().includes(query) ||
            user.lastname?.toLowerCase().includes(query) ||
            user.username?.toLowerCase().includes(query) ||
            user.email?.toLowerCase().includes(query) ||
            user.role_name?.toLowerCase().includes(query) ||
            user.status?.toLowerCase().includes(query) ||
            user.designation?.toLowerCase().includes(query)
        );
    });

    const handleToggleChange = async (id) => {
        const currentState = toggleStates[id];
        const newState = !currentState;
        const newStatus = newState ? 'ACTIVE' : 'INACTIVE';

        // Optimistically update the UI immediately
        setToggleStates(prev => ({
            ...prev,
            [id]: newState
        }));

        try {
            setLoading(true);
            const response = await axios.put(
                `${baseUrl}/user/${id}`,
                { status: newStatus },
                { headers }
            );


            if (response?.status === 200) {
                setShowSuccessPopup({
                    type: "success",
                    show: true,
                    message: 'User Updated Successfully',
                });
            }

            setShouldRefetch(true);

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('API error:', error);
        }
    };


   const handlePasswordReset = async (user) => {
  try {
    setLoading(true);

    // First check if user is verified
    // if (!user.is_email_verified) {
    //   setShowSuccessPopup({
    //     type: "warning",
    //     show: true,
    //     message: "User must verify email first",
    //   });
    //   return;
    // }

    const response = await axios.post(
      `${baseUrl}/user/initiate-password-reset`,
      { userId: user.id },
      { headers }
    );

    if (response.data.success) {
      setShowSuccessPopup({
        type: "success",
        show: true,
        message: `Password reset email sent to ${response.data.data?.email || user.email}`,
      });
    } else {
      setShowSuccessPopup({
        type: "warning",
        show: true,
        message: response.data.message || "Failed to send reset email",
      });
    }
  } catch (error) {
    console.error("Password reset error:", {
      status: error.response?.status,
      data: error.response?.data,
      user: user.id
    });

    setShowSuccessPopup({
      type: "warning",
      show: true,
      message: error.response?.data?.message || 
             (error.response?.status === 404 ? "User not found" : "Failed to send reset email"),
    });
  } finally {
    setLoading(false);
  }
};

    const handleSendVerificationMail = async (user) => {
    try {
        setLoading(true);
        const response = await axios.post(
        `${baseUrl}/user/resend-verification`,
        { userId: user.id },
        { headers }
        );

        if (response.data.success) {
        setShowSuccessPopup({
            type: "success",
            show: true,
            message: response.data.message || 'Verification email resent successfully',
        });
        } else {
        setShowSuccessPopup({
            type: "warning",
            show: true,
            message: response.data.message || "Failed to resend verification email",
        });
        }
    } catch (error) {
        setShowSuccessPopup({
        type: "error",
        show: true,
        message: error.response?.data?.message || "Failed to resend verification email",
        });
    } finally {
        setLoading(false);
    }
    };

    return (
        <div className="container-fluid">
            {isLoading && <GlobalLoader />}
            <div className="row theme-container rounded custom-shadow mx-2">
                <div className="col-6">
                    <div className="py-3 px-2 d-flex justify-content-start">
                        <button type="submit" className="btn btn-primary py-2 px-3 fw-500 d-flex justify-content-center align-items-center"
                            onClick={() => setIsModalOpen(true)}>
                            <span className="fnt16"><i className="bi bi-plus "></i></span> Add New User
                        </button>
                    </div>
                </div>

                <div className="col-6 d-flex align-items-center justify-content-end">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ width: '300px' }}
                    />
                </div>


                <div className="col-12 mt-1">
                    <div style={{ maxHeight: 'calc(100vh - 275px)', overflowY: 'scroll' }}>
                        <table className="user-management-table">
                            <thead>
                                <tr className="user-management-table-tr" style={{ backgroundColor: '#001744', color: 'white' }}>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>User Name</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>Designation</th>
                                    <th>Created On</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData?.map((user, idx) => (
                                    <tr key={idx} style={{ textAlign: 'center' }}>
                                        <td title={user.firstname}>{truncateText(user.firstname, 10)}</td>
                                        <td title={user.lastname}>{truncateText(user.lastname, 10)}</td>
                                        <td title={user.username}>{truncateText(user.username, 20)}</td>
                                        <td title={user.email} style={{ color: 'brown' }}>{truncateText(user.email, 40)}</td>
                                        <td>{user.role_name}</td>
                                        <td>{user.designation}</td>
                                        <td>{dateTimeFormatter(user.created_at)}</td>
                                        <td>
                                            <span
                                                style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '5px',
                                                    backgroundColor:
                                                        user?.status?.toLowerCase() === 'active' ? '#d4f8dc' : '#ffd4d4',
                                                    color: user?.status?.toLowerCase() === 'active' ? '#3da35d' : '#cc0000',
                                                    fontSize: '12px',
                                                }}
                                            >
                                                {user?.status?.charAt(0) + user?.status?.slice(1)?.toLowerCase()}
                                            </span>
                                        </td>
                                        <td className="d-flex align-items-center justify-content-center">
 
                                            <span style={{ margin: '0 5px',cursor: user.is_email_verified ? 'not-allowed' : 'pointer',fontSize: '16px',opacity: user.is_email_verified ? 0.6 : 1}} title={user.is_email_verified ? "Email already verified" : "Click to send verification email"} onClick={!user.is_email_verified ? () => handleSendVerificationMail(user) : undefined}>
                                               <i className="bi bi-envelope" style={{ color: user.is_email_verified ? '#adb5bd' : '#007bff', ...(user.is_email_verified && { color: '#adb5bd !important' }) }}/>
                                            </span>
   


                                            <span style={{margin: '0 5px',cursor: user.is_email_verified ? 'pointer' : 'not-allowed',fontSize: '16px'}} title={user.is_email_verified ? "Send email for password reset" : "Verify email first"} onClick={user.is_email_verified ? () => handlePasswordReset(user) : undefined}>
                                                <i className="bi bi-lock-fill" style={{color: user.is_email_verified ? '#007bff' : '#adb5bd', opacity: user.is_email_verified ? 1 : 0.7, pointerEvents: user.is_email_verified ? 'auto' : 'none'}} />
                                            </span>

                                            <span style={{ margin: '0 5px', cursor: 'pointer', fontSize: '16px' }} title="Update user details"
                                                onClick={() => handleEditUser(user)}><i className="bi bi-pencil-square text-warning"></i></span>
                                            <span style={{ margin: '0 5px', cursor: 'pointer', fontSize: '16px' }} title="Update permissions"
                                                onClick={() => handleAccessUser(user)}><i className="bi bi-gear-fill text-primary"></i></span>
                                            <span style={{ margin: '0 5px', cursor: 'pointer', fontSize: '16px' }} title="Delete User"
                                                onClick={() => handleDeleteUser(user)}><i className="bi bi-trash-fill text-danger"></i></span>
                                             <span 
                                            style={{ marginLeft: '20px', display: 'inline-block' }}
                                            title={!(user.is_email_verified && user.is_password_reset) ? 
                                            "User must verify email and complete password reset to activate" : 
                                            "Toggle user status"}
  >
                                                <div className="form-check form-switch">
                                                    <input
                                                        className={`form-check-input custom-switch ${toggleStates[user.id] ? 'switch-on' : 'switch-off'}`}
                                                        type="checkbox"
                                                        role="switch"
                                                        id={`flexSwitchCheckChecked`}
                                                        checked={toggleStates[user.id] || false}
                                                        onChange={() => {
                                                                         if (user.is_email_verified && user.is_password_reset) {
                                                                              handleToggleChange(user?.id);
                                                                            }}}
                                                        disabled={!(user.is_email_verified && user.is_password_reset)}
                                                    />
                                                </div>
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <label className="fnt12 fw-500 text-secondary">
                                Rows per page:
                            </label>
                            <CustomSelect
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                options={[10, 25, 50, 100]}
                            />
                        </div>
                        <div>
                            <MdKeyboardArrowLeft
                                size={24}
                                style={{
                                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                    opacity: currentPage === 1 ? 0.5 : 1,
                                }}
                                onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                            />

                            <span className="mx-2 fnt12 fw-500 text-secondary">
                                Page {currentPage} of {totalPages}
                            </span>

                            <MdKeyboardArrowRight
                                size={24}
                                style={{
                                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                    opacity: currentPage === totalPages ? 0.5 : 1,
                                }}
                                onClick={() =>
                                    currentPage < totalPages && handlePageChange(currentPage + 1)
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>


            <DynamicModal
                heading={formData?.id ? 'Update User' : 'New User'}
                isModalOpen={isModalOpen}
                id={formData?.id ? 'existing-user' : 'new-user-form'}
                setIsModalOpen={setIsModalOpen}
                formData={formData}
                handleInputChange={handleInputChange}
                handleSave={handleSave}
                fields={newUserFieldForamt}
                handleCloseModal={() => handleCloseModal(false)}
            />

            <SuccessPopup
                type={showSuccessPopup?.type}
                show={showSuccessPopup?.show}
                message={showSuccessPopup?.message}
                onClose={() => setShowSuccessPopup(false)}
            />

            <ConfirmPopup
                show={showConfirmPopup}
                message="Are you sure you want to delete this user?"
                onCancel={() => setShowConfirmPopup(false)}
                onConfirm={handleConfirmDelete}
            />
        </div>
    )
}

export default UserManagement;